// Thin re-exports so the banner can live in components/common without a
// circular import into the adapter.
export { isDemo, exitDemo } from './demoMode';
export function resetDemoDbSafe() {
  // Lazy: the adapter module may not be loaded yet in a non-demo tab
  import('./demoAdapter').then(m => m.resetDemoDb()).catch(() => {});
}
